const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const withMinimalLoading = <T>(fn: () => Promise<T>, minLoadingTime: number): (() => Promise<T>) => {
  return () => Promise.all([fn(), wait(minLoadingTime)]).then(([data]) => data);
};
